import * as _ from "lodash"

const jsDataOperatorToSqlOperator: any = {
  neq: "<>",
  lt: "<",
  lte: "<=",
  gt: ">",
  gte: ">=",
  inq: "in",
  nin: "not in",
  eq: "="
};

const jsDataOperatorToIncludeBool: any = {
  neq: false,
  inq: true,
  nin: false,
  eq: true
};

export interface IPathInfo {
  obj: any
  path: string
  propertyParent: any
  propertyName: string
}


export class JSONUtils {

  static parse(text: string, defaultValue: any) {
    try {
      return (JSON.parse(text))
    } catch(err){
    }

    return defaultValue
  }

  static getPathInfo(obj: any, path: string): IPathInfo {

    let rv: IPathInfo = {
      obj: obj,
      path: path,
      propertyName: undefined,
      propertyParent: undefined
    }
    if(_.isEmpty(obj) || _.isEmpty(path))
      return rv

    let propertyParent = obj
    let pathItems = path.split("/")
    _.forEach(pathItems, (nextPropName: string, idx: number) => {
      if(_.isEmpty(propertyParent))
        return

      if(idx == (pathItems.length - 1)){
        if(nextPropName in propertyParent){
          rv.propertyParent = propertyParent
          rv.propertyName = nextPropName
        }

        return
      }

      // See if we can walk up
      if(_.isArray(propertyParent)){
        // Next Prop Name should be a number index
        if(_.isNumber(+nextPropName)){
          propertyParent = propertyParent[+nextPropName]
          return
        }
        return false // can't walk up array index
      }

      if(_.isPlainObject(propertyParent)) {
        if (nextPropName in propertyParent) {
          propertyParent = propertyParent[nextPropName]
          return
        }
        return false  // can't walk up Plain Object index
      }

      return false   // don't recognize object
    })

    return rv
  }

  static removePaths(obj: any, paths: string[]): void {
    _.forEach(paths, (path) => {
      let pi = JSONUtils.getPathInfo(obj, path)
      if(!_.isEmpty(pi?.propertyParent))
        delete pi.propertyParent[pi.propertyName]
    })
  }


  //taking two filter criteria, will return a third with any common criteria and copies of inputs with common elements removed
  static getOverlappingCriteria(source: any, target: any) : {source: any, target: any, common: any} {

    let src: any = _.cloneDeep(source);
    let tgt: any = _.cloneDeep(target);
    let common: any = {};

    JSONUtils.cleanObjects(src, tgt, common);

    return {source: src, target: tgt, common: common};
  }

  private static cleanObjects(source: any, target: any, common: any) {

    if (_.isEmpty(source) || _.isEmpty(target)) {
      return;
    }

    _.forEach(source, (aProp, aPropName) => {
      if (aPropName in target) {

        if (typeof source[aPropName] === 'string' || typeof source[aPropName] === 'number') {
          if (source[aPropName] == target[aPropName]) {
            common[aPropName] = source[aPropName];
            delete source[aPropName];
            delete target[aPropName];
            return;
          }

        }

        let firstKey = _.first(_.keys(source[aPropName]));
        if (firstKey in jsDataOperatorToSqlOperator) {


          if ((typeof target[aPropName] === 'number' || typeof target[aPropName] === 'string')) {
            if (_.isArray(aProp[firstKey])) {
              common[aPropName] = {};
              common[aPropName][firstKey] = [];
              let dctSrce = _.keyBy(aProp[firstKey], (aVal) => {return aVal});
              if (target[aPropName] in dctSrce) {
                common[aPropName][firstKey].push(target[aPropName]);
                delete dctSrce[target[aPropName]];
                delete target[aPropName];
                if (!_.isEmpty(dctSrce)) {
                  aProp[firstKey] = _.values(dctSrce);
                } else {
                  delete source[aPropName];
                }
                return;
              }
            } else {
              if (firstKey in jsDataOperatorToIncludeBool && target[aPropName] == aProp[firstKey] && jsDataOperatorToIncludeBool[firstKey]) {
                common[aPropName] = {};
                common[aPropName][firstKey] = target[aPropName];
                delete source[firstKey];
                delete target[aPropName];
                return;
              } else {
                return;
              }
            }
          }

          if (firstKey in target[aPropName] && !_.isArray(source[aPropName][firstKey]) && !_.isArray(target[aPropName][firstKey])) {
            if (source[aPropName][firstKey] == target[aPropName][firstKey]) {
              common[aPropName] = {};
              common[aPropName][firstKey] = target[aPropName][firstKey];
              delete source[aPropName];
              delete target[aPropName];
              return;
            }
          }

          if (firstKey in target[aPropName] && _.isArray(source[aPropName][firstKey]) && _.isArray(target[aPropName][firstKey])) {

            let dctTgt = _.keyBy(target[aPropName][firstKey], (aVal) => {return aVal});
            let dctSrc = _.keyBy(source[aPropName][firstKey], (aVal) => {return aVal});
            let commonVal: any[] = [];
            _.forEach(source[aPropName][firstKey], (aVal) => {
              if (aVal in dctTgt) {
                commonVal.push(aVal);
                delete dctTgt[aVal];
                delete dctSrc[aVal];
              }
            });
            if (!_.isEmpty(commonVal)) {
              common[aPropName] = {};
              common[aPropName][firstKey] = commonVal;
            }

            if (_.isEmpty(dctSrc)) {
              delete source[aPropName];
            } else {
              source[aPropName][firstKey] = _.values(dctSrc);
            }

            if (_.isEmpty(dctTgt)) {
              delete target[aPropName];
            } else {
              target[aPropName][firstKey] = _.values(dctTgt);
            }

          }
        }
      }
    });

  }

}